import React, { useState } from "react";
import "./Login.css";
import logo from "./images/logo_black.png";
import { Link, useHistory } from "react-router-dom";
import { auth } from "./firebase";
import BreadCrumb from "./BreadCrumb";
import Register from "./componets/Register/Register";

function Login() {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  //login
  const signIn = (event) => {
    event.preventDefault();
    // auth.signInWithPopup().
    auth
      .signInWithEmailAndPassword(email, password)
      .then((auth) => {
        history.push("/");
      })
      .catch((error) => alert(error.message));
  };

  const _style_ = {
      display: `none`,
  }

  const showForm = {
      display:`block`,
  }


  //show regesiter dailog
  const ShowRegSection =(e)=>{
      e.preventDefault();
      showForm();

  }

  //create user
  const register = event => {
      event.preventDefault()
      auth.createUserWithEmailAndPassword(email, password)
          .then(auth => {
          history.push('/')
          })
      .catch(error => alert(error.message))
  }

  return (
    <div className="login">
      <BreadCrumb pagename={" Login"}>
        <Link>
          <p>Register</p>
        </Link>
      </BreadCrumb>

      <Link to="/">
        <img className="login__logo" src={logo} />
      </Link>

      <div className="login__container">
        <h1>Sign-In</h1>

        <form>
          <h5>E-mail</h5>
          <input
            type="text"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />

          <h5>Password</h5>
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />

          <button
            type="submit"
            onClick={signIn}
            className="login__signInButton"
          >
            Sign In
          </button>
        </form>

        <p>
          By signing-in you agree to Wuzi's Conditions of Use & Sale. Please see
          our Privacy Notice, Our Cookies Notice and our Interest-Based Ads
          Notice.
        </p>

        <button onClick={register} className="login__registerButton">
          Create your Wuzi Account
        </button>
      </div>
      {/* <Register className="reg__modal" style={_style_} /> */}
    </div>
  );
}

export default Login;
